import { Grid, Box, Container, Stack, Typography } from "@mui/material";
import KpiCard from "../../components/ui/kpiCard";
import Page from "../../components/Page";



export default function AnalyticsDashboard() {
    return (
        <Page title="Analyse">
            <Container sx={{ marginTop: { xs: 3, sm: 0 } }}>
                <Stack spacing={5}>
                    <Box>
                        <Typography variant="h4">Vue globale</Typography>
                        <Typography color={'text.secondary'} fontSize={16}>Vue d'ensemble de vos performances</Typography>
                    </Box>
                    <Box>
                        {/* KPI ROW */}
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={3}>
                                <KpiCard title="Billets vendus" value="4 230" trend="+12%" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <KpiCard title="Chiffre d'affaires" value="8 450 000 FCFA" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <KpiCard title="Événements actifs" value="6" />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <KpiCard title="Taux de remplissage" value="78%" />
                            </Grid>
                        </Grid>
                    </Box>
                </Stack>

            </Container>

        </Page>

    );
}
